
import { WorldCountry } from '../types';

export const colombiaData: WorldCountry = {
  code: 'CO',
  name: 'Colombia',
  slug: 'colombia',
  population: 50882891,
  topCities: [
    { name: 'Bogotá', slug: 'bogota', population: 7412566 },
    { name: 'Medellín', slug: 'medellin', population: 2569000 },
    { name: 'Cali', slug: 'cali', population: 2227642 },
    { name: 'Barranquilla', slug: 'barranquilla', population: 1206319 },
    { name: 'Cartagena', slug: 'cartagena-co', population: 876885 },
    { name: 'Cúcuta', slug: 'cucuta', population: 650011 },
    { name: 'Soledad', slug: 'soledad', population: 645889 },
    { name: 'Ibagué', slug: 'ibague', population: 529635 },
    { name: 'Bucaramanga', slug: 'bucaramanga', population: 527913 },
    { name: 'Soacha', slug: 'soacha', population: 522442 },
    { name: 'Santa Marta', slug: 'santa-marta', population: 499192 },
    { name: 'Villavicencio', slug: 'villavicencio', population: 498384 },
    { name: 'Valledupar', slug: 'valledupar', population: 464728 },
    { name: 'Pereira', slug: 'pereira', population: 464719 },
    { name: 'Montería', slug: 'monteria', population: 453251 },
    { name: 'Manizales', slug: 'manizales', population: 434403 },
    { name: 'Pasto', slug: 'pasto', population: 392930 },
    { name: 'Neiva', slug: 'neiva', population: 357000 },
    { name: 'Armenia', slug: 'armenia-co', population: 315328 },
    { name: 'Sincelejo', slug: 'sincelejo', population: 296555 },
    { name: 'Popayán', slug: 'popayan', population: 277270 },
    { name: 'Floridablanca', slug: 'floridablanca', population: 267385 },
    { name: 'Itagüí', slug: 'itagui', population: 281853 },
    { name: 'Dosquebradas', slug: 'dosquebradas', population: 200695 },
    { name: 'Tunja', slug: 'tunja', population: 181407 },
    { name: 'Envigado', slug: 'envigado', population: 175337 },
    { name: 'Palmira', slug: 'palmira', population: 158919 },
    { name: 'Buenaventura', slug: 'buenaventura', population: 324207 },
    { name: 'Cartago', slug: 'cartago', population: 134827 },
    { name: 'Bello', slug: 'bello', population: 483574 },
    { name: 'Girardot', slug: 'girardot', population: 132719 },
    { name: 'Maicao', slug: 'maicao', population: 162318 },
    { name: 'Riohacha', slug: 'riohacha', population: 169311 },
    { name: 'Barrancas', slug: 'barrancas', population: 32436 },
    { name: 'Uribia', slug: 'uribia', population: 16084 },
    { name: 'Manaure', slug: 'manaure', population: 85507 },
    { name: 'Apartadó', slug: 'apartado', population: 195738 },
    { name: 'Turbo', slug: 'turbo', population: 160267 },
    { name: 'Quibdó', slug: 'quibdo', population: 115711 },
    { name: 'Caucasia', slug: 'caucasia', population: 102940 },
    { name: 'Corozal', slug: 'corozal', population: 61597 },
    { name: 'Sahagún', slug: 'sahagun', population: 95719 },
    { name: 'Cereté', slug: 'cerete', population: 84743 },
    { name: 'Lorica', slug: 'lorica', population: 114215 },
    { name: 'Planeta Rica', slug: 'planeta-rica', population: 64958 },
    { name: 'Montelíbano', slug: 'montelibano', population: 76092 },
    { name: 'Tierralta', slug: 'tierralta', population: 105636 },
    { name: 'Valencia', slug: 'valencia-co', population: 49432 },
    { name: 'Ciénaga de Oro', slug: 'cienaga-de-oro', population: 51794 },
    { name: 'Ayapel', slug: 'ayapel', population: 50397 },
    { name: 'Pueblo Nuevo', slug: 'pueblo-nuevo', population: 34289 }
  ]
};
